/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ErrorStatusIcon = createIcon("ErrorStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#DE3333';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.595 7.024 8.976.404a1.381 1.381 0 00-1.953 0L.404 7.024a1.382 1.382 0 000 1.953l6.62 6.619a1.38 1.38 0 001.952 0l6.62-6.619a1.381 1.381 0 000-1.953Zm-8.239-2.88a.69.69 0 111.381 0v4.144a.69.69 0 11-1.38 0V4.145Zm.726 7.949h-.02a1.056 1.056 0 01-1.05-1.015 1.018 1.018 0 011-1.057h.019c.566.002 1.03.45 1.05 1.015a1.018 1.018 0 01-.999 1.057Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});